import demandErrorFlagMessages from "../config/demandErrorFlagMessages.json";

export const normalizeErrorFlag = (errorFlag) => {
  if (!errorFlag) return {};
  if (typeof errorFlag === "string") {
    try {
      return JSON.parse(errorFlag);
    } catch {
      return {};
    }
  }
  return typeof errorFlag === "object" ? errorFlag : {};
};

export const getActiveDemandErrorMessages = (errorFlag) => {
  const normalizedErrorFlag = normalizeErrorFlag(errorFlag);

  return Object.entries(demandErrorFlagMessages)
    .filter(([key]) => String(normalizedErrorFlag[key] || "").trim().toUpperCase() === "Y")
    .map(([, message]) => message);
};

export const getUniqueErrorMessagesFromData = (dataArray) => {
  const messageSet = new Set();
  (dataArray || []).forEach((row) => {
    const messages = getActiveDemandErrorMessages(row?.error_flag);
    messages.forEach((msg) => messageSet.add(msg));
  });
  return Array.from(messageSet).sort();
};